function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillOpacity: 0.5,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#F5CCE0",
  stroke: "#F5CCE0"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M52 .5c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06h0v7.519c-1.596.121-3.03.819-4.096 1.885C48.228 12.58 47.5 14.205 47.5 16c0 1.75.692 3.34 1.818 4.509 1.028 1.067 2.417 1.783 3.97 1.952h0l.212 7.546c-.002.411-.17.784-.44 1.054-.27.271-.646.439-1.06.439h0H2c-.414 0-.79-.168-1.06-.44C.667 30.79.5 30.415.5 30h0v-7.519c1.596-.121 3.03-.819 4.096-1.885C5.772 19.42 6.5 17.795 6.5 16c0-1.75-.692-3.34-1.818-4.509C3.654 10.424 2.265 9.708.712 9.54h0L.5 1.993C.502 1.582.67 1.21.94.94 1.21.668 1.585.5 2 .5h0z",
  transform: "translate(-2117 -747) translate(1960.5 134) translate(0 24) translate(28.5 64) translate(0 56) translate(0 375) translate(128 16) translate(0 74) translate(0 4)"
})))))))))));

var SvgIconDiscountTicket = function SvgIconDiscountTicket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    viewBox: "0 0 54 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDiscountTicket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-discount-ticket.9b59a107.svg";
export { ForwardRef as ReactComponent };